export default "__VITE_ASSET__DDeBnVd2__"